<template>
  <UserFavourites
    @favouritesCountChange="showDrawerOnFavouritesChange"
    v-slot="{ currentUser, favourites, favouritesCount, removeFavourite }"
    ><portal to="favouriteDrawerPortal">
      <Drawer class="NavFavouriteDrawer__drawer" :open="open" @close="open = false" v-if="mobileVariant">
        <header class="py-6 border-b text-center font-bold">
          <h1 class="text-md font-bold">
            {{ currentUser ? `My Favourites (${favouritesCount})` : `Unsaved Favourites (${favouritesCount})` }}
          </h1>
        </header>
        <section
          class="NavFavouriteDrawer__content px-8 transition-height"
          :class="{ 'overflow-y-auto': favouritesCount > 0, 'has-more': favouritesCount > 1 }"
        >
          <FavouriteItem
            class="my-10"
            v-for="favourite in favourites"
            :key="favourite.id"
            :listing="favourite"
            :currentUser="currentUser"
            :checkoutPath="checkoutPath"
            @remove="removeFavourite(favourite.id)"
          />
          <div v-if="currentUser" class="font-bold text-center my-4 text-sm px-2">
            Looking for more favourites? Go to All Favourites.
          </div>
          <div class="flex flex-col my-8" v-if="favouritesCount == 0">
            <i class="fas fa-heart fa-4x text-primary self-center"></i>
            <h1 class="text-lg text-center mt-4">
              You don't have any favourites.
              <br />
              Tap on the heart icon to save artworks to your favourites.
            </h1>
          </div>
        </section>

        <footer class="pt-10 pb-16 px-8 bg-grey-light">
          <div class="mb-4" v-if="!currentUser">
            <p class="text-center text-lg font-bold">Save your favourites</p>
            <p class="mt-2 text-center">Enter your email to sync favourites on all devices.</p>
          </div>

          <template v-if="currentUser">
            <div class="flex -mx-4 sm:-mx-8">
              <a href="/my/favourites" class="uppercase btn btn-primary btn-bold px-2 py-6 flex-1 mx-4 sm:mx-8"
                >All Favourites</a
              >
              <a
                href="/my/followings/artists"
                class="uppercase btn btn-default-black btn-bold px-2 py-6 flex-1 mx-4 sm:mx-8"
                >Artists I Follow</a
              >
            </div>
            <div
              v-if="onboarded"
              class="flex items-center justify-between space-x-4 mt-6 px-8 py-4 text-center text-white bg-black rounded-lg"
            >
              <span>Your favourites have been synced across all devices.</span>
              <button type="button" @click="closeOnboarding()">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </template>
          <div v-else class="-mx-4 sm:-mx-8 px-8 w-full">
            <OnboardingForm :onboardPath="onboardPath" @onboardSubmitted="onOnboardSubmitted" />
          </div>
        </footer>
      </Drawer>
    </portal>
  </UserFavourites>
</template>

<script>
import Drawer from "@/components/Drawer.vue"
import UserFavourites from "@/components/UserFavouritesRenderless.js"
import FavouriteItem from "./FavouriteItem.vue"
import OnboardingForm from "./Guest/OnboardingForm.vue"

const FAVOURITE_TRIGGER_STEP = [1, 3, 6, 9]

export default {
  name: "Nav.FavouriteDrawer",
  data: () => ({
    open: false,
    onboarded: new URLSearchParams(window.location.search).has("onboarded", true),
  }),
  props: {
    onboardPath: {
      type: String,
      required: true,
    },
    checkoutPath: {
      type: String,
      required: true,
    },
  },
  methods: {
    set(value) {
      this.open = value
    },
    showDrawerOnFavouritesChange({ value, previous, currentUser }) {
      if (!this.mobileVariant) return

      const incr = value > previous
      const trigger = FAVOURITE_TRIGGER_STEP.includes(value)

      if (incr && trigger && !currentUser) this.open = true
    },
    closeOnboarding() {
      this.onboarded = false
    },
    onOnboardSubmitted() {
      this.set(false)
    },
  },
  components: {
    Drawer,
    UserFavourites,
    FavouriteItem,
    OnboardingForm,
  },
}
</script>

<style lang="scss" scoped>
.NavFavouriteDrawer__content {
  height: 180px;

  &.has-more {
    height: 34vh;

    @media (max-width: 380px) {
      height: 41vh;
    }

    @media (min-width: 768px) {
      height: 54vh;
    }
  }
}
.NavFavouriteDrawer__drawer .Drawer__content {
  max-height: 85vh;
}
</style>
